import { render } from "./ChatHeader.vue?vue&type=template&id=ce708456"
import script from "./ChatHeader.vue?vue&type=script&lang=js"
export * from "./ChatHeader.vue?vue&type=script&lang=js"

import exportComponent from "/Users/delano/projects/wp-dev/wp-content/plugins/wp-sam-chat/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__